import * as types from '../constants/ActionTypes';

export function setCurrentSection(section) {
  return {
    type: types.SET_CURRENT_SECTION,
    section
  };
}



/** WEBPACK FOOTER **
 ** ./src/js/actions/SectionNavActions.js
 **/